export function DeltaBadge({ current, previous }: { current: number; previous: number | null | undefined }) {
  if (previous == null) return null;
  const delta = current - previous;
  if (delta === 0) return null;
  const isPositive = delta > 0;
  return (
    <span className={`inline-flex items-center text-xs font-medium ml-1.5 ${isPositive ? "text-emerald-600" : "text-red-600"}`}>
      {isPositive ? "▲" : "▼"} {Math.abs(delta)}
    </span>
  );
}
